import React from "react";
import ReactDOM from "react-dom";
import "./App.less";
import App from "./App";
import './index.less'
ReactDOM.render(<App />, document.getElementById("root"));
